import {
  useSetTimetableVersionConstraintsMutation,
  useTimetableVersionConstraintsQuery,
} from '../../../types/planung-graphql-client-defs';
import { VERSION_RESOURCE_TYPE, VersionResourceKey } from '../utils/versionResourceType';

/**
 * Der Bedingungs-Blob (JSON) einer Ressource in der Version, samt Schreiben. `write` nimmt die
 * Ziel-Ressource entgegen, weil das Duplizieren denselben Blob auf andere Ressourcen der Art schreibt.
 */
export const useVersionConstraints = (versionUuid: string, resource: VersionResourceKey, resourceUuid: string) => {
  const resourceType = VERSION_RESOURCE_TYPE[resource];
  const [{ data }, refetch] = useTimetableVersionConstraintsQuery({
    variables: { versionUuid, resourceType, resourceUuids: [resourceUuid] },
    pause: !versionUuid || !resourceUuid,
    requestPolicy: 'cache-and-network',
  });
  const [, setConstraints] = useSetTimetableVersionConstraintsMutation();

  const write = async (targetUuid: string, blob: Record<string, unknown>) => {
    const { error } = await setConstraints({
      versionUuid,
      resourceType,
      resourceUuid: targetUuid,
      constraints: JSON.stringify(blob),
    });
    return { error };
  };

  return {
    raw: data?.timetableVersionConstraints.find((entry) => entry.resourceUuid === resourceUuid)?.constraints,
    resourceType,
    write,
    refetch,
  };
};
